import AiAssistantHistoryComponent from '../AiAssistantHistoryComponent.vue'

export default [
    {
        path: '/ai-assistant-history',
        name: 'AI Assistant History',
        meta: { layout: 'mystagit' },
        component: AiAssistantHistoryComponent,
    },
]
